import { useQuery } from "react-query";
import yearPlanAPI from "../../../api/yearPlanAPI";

export const useYearPlan = (id) =>
  useQuery(["yearPlans", id], () => yearPlanAPI.fetchYearPlan(id), {
    enabled: !!id,
  });
